import { FormControl, ValidationErrors } from '@angular/forms';

export const confirmPasswordValidation = (
  newPasswordFormControl: FormControl
) => (control: FormControl) =>
  control.value === newPasswordFormControl?.value
    ? null
    : { confirmpassword: true };

export const addErrorsToFormControl = (
  control: FormControl,
  errors: ValidationErrors
) => {
  const existingErrors = control?.errors;

  const mergedErros = { ...existingErrors, ...errors };

  control?.setErrors(
    Object.keys(mergedErros)?.length > 0 ? mergedErros : null,
    { emitEvent: false }
  );
};

export const removeErrorsFromFormControl = (
  control: FormControl,
  errors: ValidationErrors
) => {
  const existingErrors = control?.errors || {};

  Object.keys(errors).forEach((key) => {
    delete existingErrors?.[key];
  });

  control?.setErrors(
    Object.keys(existingErrors)?.length > 0 ? { ...existingErrors } : null
  );
};

export const isFormControlReadyForAsyncValidation = (
  control: FormControl,
  asyncErrors: ValidationErrors
) => {
  if (!asyncErrors) asyncErrors = {};
  const errors = { ...control?.errors };
  Object.keys(asyncErrors)?.forEach((key) => {
    delete errors?.[key];
  });
  return Object.keys(errors)?.length === 0 ? true : false;
};
